import {
  mdiAccountOutline,
  mdiAlarm,
  mdiBookmarkOutline,
  mdiCalendarMonth,
  mdiCarOutline,
  mdiCheck,
  mdiChevronLeft,
  mdiChevronRight,
  mdiClose,
  mdiCogOutline,
  mdiCommentTextOutline,
  mdiDeleteOutline,
  mdiEmailOutline,
  mdiFilterOutline,
  mdiHistory,
  mdiLightningBoltOutline,
  mdiLinkVariant,
  mdiPaperclip,
  mdiPhoneOutline,
  mdiPlus,
  mdiPrinterOutline,
  mdiServerOutline,
  mdiSync
} from '@mdi/js';

export type CustomButtonSupportedIcon =
  | 'delete'
  | 'adf_scanner'
  | 'close'
  | 'check'
  | 'account_circle'
  | 'add'
  | 'chat'
  | 'data_table'
  | 'electric_bolt'
  | 'filter_alt'
  | 'bookmark'
  | 'chevron_forward'
  | 'chevron_left'
  | 'history'
  | 'cached'
  | 'attach_file'
  | 'link_2'
  | 'mail'
  | 'call'
  | 'settings'
  | 'alarm'
  | 'calendar_month'
  | 'local_taxi';

export const CustomButtonSupportedIcons: CustomButtonSupportedIcon[] = [
  'delete',
  'adf_scanner',
  'close',
  'check',
  'account_circle',
  'add',
  'chat',
  'data_table',
  'electric_bolt',
  'filter_alt',
  'bookmark',
  'chevron_forward',
  'chevron_left',
  'history',
  'cached',
  'attach_file',
  'link_2',
  'mail',
  'call',
  'settings',
  'alarm',
  'calendar_month',
  'local_taxi'
];

export const getCustomButtonSupportedIconByName = (name: CustomButtonSupportedIcon) => {
  switch (name) {
    case 'delete':
      return mdiDeleteOutline;
    case 'adf_scanner':
      return mdiPrinterOutline;
    case 'close':
      return mdiClose;
    case 'check':
      return mdiCheck;
    case 'account_circle':
      return mdiAccountOutline;
    case 'add':
      return mdiPlus;
    case 'chat':
      return mdiCommentTextOutline;
    case 'data_table':
      return mdiServerOutline;
    case 'electric_bolt':
      return mdiLightningBoltOutline;
    case 'filter_alt':
      return mdiFilterOutline;
    case 'bookmark':
      return mdiBookmarkOutline;
    case 'chevron_forward':
      return mdiChevronRight;
    case 'chevron_left':
      return mdiChevronLeft;
    case 'history':
      return mdiHistory;
    case 'cached':
      return mdiSync;
    case 'attach_file':
      return mdiPaperclip;
    case 'link_2':
      return mdiLinkVariant;
    case 'mail':
      return mdiEmailOutline;
    case 'call':
      return mdiPhoneOutline;
    case 'settings':
      return mdiCogOutline;
    case 'alarm':
      return mdiAlarm;
    case 'calendar_month':
      return mdiCalendarMonth;
    case 'local_taxi':
      return mdiCarOutline;
  }
};
